import { ScrollingModule } from '@angular/cdk/scrolling';
import { ChangeDetectionStrategy, Component, Signal, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatMenuModule } from '@angular/material/menu';
import { RouterLink } from '@angular/router';

import { HeaderElementDirective } from '@core/shared/util';
import { OverviewModule, RootModuleNavComponent } from '@core/ui';
import { PlatformPackagingUnit } from '@mp/system/platform-packaging-units/data-access';

import { PlatformPackagingUnitsFacade } from '../platform-packaging-units.facade';

@Component({
  selector: 'mp-list-platform-packaging-units',
  templateUrl: './list-platform-packaging-units.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, MatMenuModule, ScrollingModule, RootModuleNavComponent, HeaderElementDirective, OverviewModule],
})
export class ListPlatformPackagingUnitsComponent {
  private readonly facade: PlatformPackagingUnitsFacade = inject(PlatformPackagingUnitsFacade);

  readonly platformPackagingUnits: Signal<PlatformPackagingUnit[]> = toSignal(this.facade.packagingUnits$, {
    requireSync: true,
  });

  constructor() {
    this.getAll();
  }

  deleteUnit(shortName: string): void {
    this.facade.deleteUnit(shortName);
  }

  getAll(searchTerm?: string): void {
    this.facade.getAll(searchTerm);
  }
}
